import {FieldOverrideConfiguration} from "../config/field-override-configuration";

export class Measurement {
    parameterType: string; // type of parameter, e.g. 'Bodensaugspannung'
    stationParameterName: string; // specific paramteter type, e.g. 'Saugspannung Median [20 cm]'
    value: number; // measurement value
    relativeValue: number | null | undefined; // relative value
    date: Date; // date of measurement
    unit: string; // unit of value
    tsId: string; // Id of time series
    name: string; // Name of time series

    constructor(
        props?: {
            parameterType?: string;
            stationParameterName?: string;
            value?: number;
            relativeValue?: number | null | undefined;
            date?: Date;
            unit?: string;
            tsId?: string;
            name?: string;
        }) {
        if (props) {
            Object.assign(this, props);
        }
    }

    /**
     * Apply overrides
     * Overrides can be used to change original values
     */
    applyOverrides(overrides: FieldOverrideConfiguration[]) {
        if (!overrides || !overrides.length) {
            return;
        }

        const applicableOverrides = overrides.filter((ov) =>
            ov.parameterTypes.indexOf(this.parameterType) !== -1
        );

        // noinspection DuplicatedCode
        const that = this;
        applicableOverrides.forEach((over: FieldOverrideConfiguration) => {
            if (over.queryExpression.evaluate(that)) {
                let value = over.valueExpression;
                if (value.includes("${")) {
                    value = `${value.evaluate(that)}`;
                }
                that[over.fieldName] = value;
            }
        });
    }
}
